import { required, requiredIf } from 'vuelidate/lib/validators';

const mStep = {
  title: 'Review - Overall',
  description: 'Please provide details of the investment strategy review.',
};

const factors = [
  'bushfires in areas that affect the Fund\'s assets',
  'floods in areas that affect the Fund\'s assets',
  'the COVID-19 pandemic and associated economic conditions',
  'other',
];
export default {
  name: 'inv-strat-review-overall',
  data: () => ({
    mStep,
    factors,
  }),
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    hasOtherReason: {
      get() {
        return this.getItem.review.specific.otherReason.hasOtherReason;
      },
      set(value) {
        if (value === 'No') {
          // eslint-disable-next-line max-len
          this.setItem({ review: { specific: { otherReason: { hasOtherReason: value, otherReasons: [] } } } });
        } else {
          this.setItem({ review: { specific: { otherReason: { hasOtherReason: value } } } });
        }
      },
    },
    otherReasons: {
      get() {
        return this.getItem.review.specific.otherReason.otherReasons;
      },
      set(value) {
        if (!value.includes('other')) {
          this.setItem({ review: { specific: { otherReason: { otherReasons: value, otherReason: '' } } } });
        } else {
          this.setItem({ review: { specific: { otherReason: { otherReasons: value } } } });
        }
      },
    },
    otherReason: {
      get() {
        return this.getItem.review.specific.otherReason.otherReason;
      },
      set(value) {
        this.setItem({ review: { specific: { otherReason: { otherReason: value } } } });
      },
    },
  },
  methods: {
    setItem(item) {
      this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
  },
  validations() {
    if (this.hasOtherReason === 'Yes') {
      return {
        otherReason: {
          required: requiredIf(function otherRequired() {
            if (this.otherReasons.findIndex(value => value === 'other') >= 0) {
              return true;
            }
            return false;
          }),
        },
        hasOtherReason: {
          required,
        },
        otherReasons: {
          required,
        },
      };
    }
    return {
      hasOtherReason: {
        required,
      },

    };
  },
};
